'use client';

import { createContext } from "react";
const defaultContextValue = {
  bodyFont: void 0,
  titleFont: void 0,
  primaryColor: void 0,
  borderRadius: void 0
};
const ChalkThemeContext = createContext(defaultContextValue);
const ChalkThemeContextProvider = ChalkThemeContext.Provider;
export {
  ChalkThemeContext,
  ChalkThemeContextProvider
};
